import { PropertyContext, TourPage, TourSignupProps } from './TourRouter';
import { useTourNavigation } from './TourStateMachine';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { useContext, useState, useEffect, useMemo } from 'react';
import {
    getGuestCard,
    getReservationForGuestCard,
    GuestCard,
    Reservation
} from '../../../../api/TourSignup';
import LoadingOverlay from '../../../common/LoadingOverlay';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import { SourceType } from '../../../../utilities/Enums';
import { useFetch } from '../../../../hooks/useFetch';
import { getProspectUserPreferences } from '../../../../api/ProspectUserProfile';
import GuestCardForm from './GuestCardForm';
import GuestCardDisplay from './display/GuestCardDisplay';
import '../../../../styles/TourContactInfoForm.css';
import { getSourceData } from '../../../../utilities/sourceData';
import ReservationDisplay from './display/ReservationDisplay';
import * as moment from 'moment';

const GuestCardPage = (props: TourSignupProps) => {
    const property = useContext(PropertyContext);
    if (!property) {
        return null;
    }

    const guestCardGuid = props.match.params.guestCardGuid;

    const goForward = useTourNavigation(TourPage.GuestCard, props);

    const [guestCard, setGuestCard] = useState<GuestCard | undefined>(undefined);
    const [loading, setGuestCardLoading] = useState(false);
    const [guestCardError, setGuestCardError] = useState<string | undefined>(undefined);
    const [reservation, setReservation] = useState<Reservation | undefined>(undefined);

    const {
        data: preferences,
        loading: preferencesLoading,
        error: preferencesError
    } = useFetch(getProspectUserPreferences, [], undefined);

    const leavePage = () => {
        goForward(guestCardGuid);
    };

    const loadExisting = async () => {
        if (!guestCardGuid) {
            return;
        }
        setGuestCardLoading(true);
        const guestCardRequest = getGuestCard(property.id, guestCardGuid);
        const reservationRequest = getReservationForGuestCard(guestCardGuid);

        const guestCardResponse = await guestCardRequest;
        if (guestCardResponse.data) {
            setGuestCard(guestCardResponse.data);
        }

        const reservationResponse = await reservationRequest;
        if (reservationResponse.data) {
            setReservation(reservationResponse.data);
        }

        setGuestCardError(reservationResponse.error || guestCardResponse.error);
        setGuestCardLoading(false);
    };

    useEffect(() => {
        loadExisting();
    }, []);

    const sourceData = useMemo(() => {
        return getSourceData();
    }, []);

    return (
        <div>
            <LoadingOverlay show={loading || preferencesLoading} inBootstrapColumn={true} />
            <h3 className="prospect-signup-header">Schedule Your Tour</h3>
            <FormValidationDisplay errorMessage={guestCardError || preferencesError} />
            {!guestCard ? (
                preferences && (
                    <GuestCardForm
                        initialGuestCard={
                            guestCard || {
                                preferences: {
                                    ...preferences,
                                    desiredMoveInDate:
                                        preferences.desiredMoveInDate &&
                                        moment(preferences.desiredMoveInDate).isAfter()
                                            ? preferences.desiredMoveInDate
                                            : undefined
                                },
                                source: sourceData.source,
                                sourceType: sourceData.sourceType || SourceType.None,
                                sessionId: sourceData.sessionId,
                                sourceMedium:
                                    sourceData.sourceMedium != null
                                        ? sourceData.sourceMedium
                                        : null,
                                sourceCampaign:
                                    sourceData.sourceCampaign != null
                                        ? sourceData.sourceCampaign
                                        : null,
                                unitTypeId: undefined
                            }
                        }
                        goForward={goForward}
                    />
                )
            ) : (
                <div>
                    <header className="existing-guest-card">
                        <h4>Existing Guest Card</h4>
                    </header>
                    <GuestCardDisplay guestCard={guestCard} />
                    {reservation && <ReservationDisplay reservation={reservation} />}
                    <div className="navigation-buttons">
                        <button
                            type="button"
                            className="btn btn-primary font-weight-bold"
                            onClick={() => leavePage()}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default withRouter(GuestCardPage);



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/GuestCardPage.tsx